<template>
      <div class="wrapper wrapper-content">
        <div class="container-fluid">

<div class="">

  <div class="row">
    <div class="col-lg-12">
      <div class="ibox ">
        <div class="ibox-title">
          <h5>เลขชุด</h5>
        </div>

        <div class="ibox-content">

          <div class="row">
            <div class="col-xs-6 col-sm-3 m-b-xs"></div>
            <div class="col-xs-6 col-sm-9 text-right">
              <router-link :to="{name: 'addnumber'}" class="btn btn-primary "><i class="fa fa-plus"></i> สร้างเลขชุด</router-link>
            </div>
          </div> <!-- /.row -->

        <div class="tab-content">
            <div class="tab-pane active">
                <div class="panel-body p-xs">
                    <div class="col-xs-12">

                        <data-tables :data="userNumberSet" :pagination-props="{ pageSizes: [10, 25, 50, 100] }" :table-props="tableProps">
                          <el-table-column prop="name" label="ชื่อเลขชุด" width="auto" >
                          </el-table-column>

                          <el-table-column prop="created_at" label="วันที่สร้าง" width="auto">
                              <template slot-scope="scope">
                                <div>{{ formatDate(scope.row.created_at) }} </div>
                              </template>
                          </el-table-column>

                          <el-table-column prop="edit" label="แก้ไข" width="auto" >
                            <template slot-scope="scope">
                                <a href="#number-sets-modal" data-toggle="modal" class="btn btn-xs btn-primary" @click="getUserNumber(scope.row.id)"><i class="fa fa-list"></i> รายละเอียด</a>
                                <button type="button" class="btn btn-xs btn-danger btn-refund" @click.once="deleteUserNumber(scope.row.id)"><i class="fa fa-times" ></i> ลบ</button>

                            </template>
                          </el-table-column>
                        </data-tables>

                    </div>
                    <div class="text-right m-t-sm">
                    </div>
                    <!-- <span class="text-primary-new">อัพเดตล่าสุด {{ lastUpdate }}</span> -->
                </div>
            </div>
        </div>

        </div> <!-- /.ibox-content -->
      </div> <!-- /.ibox -->
    </div> <!-- /.col-lg-12 -->
  </div> <!-- /.row -->




<div id="number-sets-modal"  role="dialog" aria-hidden="true" class="modal inmodal">
    <div class="modal-dialog">
        <div class="modal-content animated fadeIn">
        
        <div class="modal-header">
            <button type="button" data-dismiss="modal" class="close">
            <span aria-hidden="true">×</span>
            <span class="sr-only">Close</span>
            </button> 
            <h4 class="modal-title">{{ show_name }}</h4>
        </div>

        <div class="modal-body">
            <table class="table table-bordered table-striped table-hover">         
                <tbody>
                    <tr v-for="(item, index) in show_detail" :key="'show_detail-' + index">
                        <th>{{ bettypeTextMapping[item.bettype_id] }}</th>
                        <th>{{ item.number }}</th>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

  </div><!-- /#modal dialog -->
</div><!-- /#modal -->


            </div>

        </div>
      </div><!-- /#page-wrapper -->
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'

export default {
    name: 'numberset',
    data () {
        return {
            query: {
                sort: '',
                order: 'desc',
                page: 0,
                limit: 5,
            },
            userNumberSet: [],
            lastUpdate: new Date().toLocaleString(),
            tableProps: {
                border: true,
                stripe: true,
                defaultSort: {
                    prop: 'created_at',
                    order: 'descending'
                },
            },
            un_name: '',
            un_number: '',
            un_bettype_id: 4,

            un_number_set: [],

            show_name: '',
            show_detail: {},

            // bettypeTextMapping: {
            //     threetop: 'สามตัวบน',
            //     threemix: 'สามตัวโต๊ด',
            //     twotop: 'สองตัวบน',
            //     twodown: 'สองตัวล่าง',
            //     runtop: 'วิ่งบน',
            //     rundown: 'วิ่งล่าง',
            // },

            // bettypeCodeMapping: {
            //     threetop: '4',
            //     threemix: '1',
            //     twotop: '6',
            //     twodown: '7',
            //     runtop: '8',
            //     rundown: '9',
            // },

            bettypeTextMapping: {
                '4': 'สามตัวบน',
                '1': 'สามตัวโต๊ด',
                '6': 'สองตัวบน',
                '7': 'สองตัวล่าง',
                '8': 'วิ่งบน',
                '9': 'วิ่งล่าง',
            },
        }
    },
    computed: {
        ...mapState({
            user: state => state.user.user,
        })
    },
    methods: {
        async loadUserNumber () {
            try {
                const response = await this.$store.dispatch('usernumber/getAllUsernumber', this.query)
                //console.log('async loadUserNumber', response)

                this.userNumberSet = response.result

            } catch (error) {
                this.$toasted.error('There was an error connecting to the server.')
            }
        },

        async deleteUserNumber (setId) {
            let loader = this.$loading.show()
            try {

                let response = await this.$store.dispatch('usernumber/deleteUsernumber', { id: setId })
                //console.log('response', response)

                if ( response.message === 'SUCCESS' ) {
                    this.$toasted.success('ลบชุดตัวเลขสำเร็จแล้ว.')
                }

            } catch (error) {
                this.$toasted.error('Your Number couldn\'t be deleted. There was an error connecting to the server.')
            } finally {
                //this.$router.go(0)
                loader.hide()
                this.$router.go(0)
            }
        },

        getUserNumber (setId) {
            //alert(setId)
            this.loadDetailUserNumber (setId)
            //this.$router.push({name: 'editnumber', query: {setId: setId}})
        },

        async loadDetailUserNumber (setId) {

            try {
                const response = await this.$store.dispatch('usernumber/getUsernumber', setId)
                //console.log('response: ', response)

                if ( response.length > 0 ) {
                    this.show_name = response[0].name
                    this.show_detail = response
                }

                
            } catch (error) {
                this.$toasted.error('There was an error connecting to the server.')
            }
        },

        formatDate (value) {
            if (value) {
                let date = new Date(value)
                return moment(date).format('DD/MM/YYYY HH:mm:ss')
            }
        },

    },

    mounted () {
    },
    created () {
        this.loadUserNumber()
        //console.log('userNumberSet', this.userNumberSet)
    },
    destroyed () {
    }
}
</script>

<style lang="sass" scoped>
</style>
